import { TourStatus } from 'api/onboarding/types';

// Explicit outcome of the running tour, set by the footer buttons (Skip /
// Finish) so the lifecycle controller logs the right status on close rather
// than inferring it. Null when closed without a button (falls back to skipped).

let outcome: TourStatus | null = null;

export const setTourOutcome = (next: TourStatus | null): void => {
	outcome = next;
};

export const getTourOutcome = (): TourStatus | null => outcome;
